import Days from 'ember-power-calendar/components/power-calendar/days';

import { action, set } from '@ember/object';

export default class BvCalendarDays extends Days {
  _updateFocused(id: string) {
    if (!this.isDestroyed) {
      set(this, 'focusedId', id);
    }
  }

  @action
  handleClick(e: MouseEvent) {
    const dayEl = (e.target as HTMLElement).closest('[data-date]');
    if (dayEl) {
      //@ts-expect-error !NOTYPES!
      const dateStr = dayEl.dataset.date;
      const day = this.days.find((d) => d.id === dateStr);
      if (day && this.args.calendar.actions.select && !day.isDisabled) {
        this.args.calendar.actions.select(day, this.args.calendar, e);
      }
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvCalendar::Days': typeof BvCalendarDays;
    'bv-calendar/days': typeof BvCalendarDays;
  }
}